// Post-login gate orchestrator. Enforces the order Volkan specified — profile
// first, then KVKK/ETK consent, then the org Terms gate — by showing exactly one
// blocking modal at a time. Personal gates (this file's concern) take precedence
// over the org Terms gate, which renders only once the personal gates are clear;
// the rewards entry fee gate comes last (rewards part 3).
//
// Mounted once in the root layout (replaces the bare <TermsAcceptanceGate/>).

import { useGateEnabled } from './useGateEnabled'
import { usePersonalGates } from './usePersonalGates'
import { ProfileCompletionGate } from './ProfileCompletionGate'
import { ConsentGate } from './ConsentGate'
import { TermsAcceptanceGate } from './TermsAcceptanceGate'
import { EntryFeeGate } from './EntryFeeGate'

export function PostLoginGates() {
  const enabled = useGateEnabled()
  const { loading, profileComplete, displayName, phone, pendingConsents, refetch } =
    usePersonalGates(enabled)
  const isLocalUiPreview =
    import.meta.env.DEV && new URLSearchParams(window.location.search).get('uiPreview') === '1'

  if (isLocalUiPreview) return null

  if (enabled && !loading) {
    if (!profileComplete) {
      return (
        <ProfileCompletionGate
          initialName={displayName}
          initialPhone={phone}
          kvkk={pendingConsents[0] ?? null}
          onDone={refetch}
        />
      )
    }
    if (pendingConsents.length > 0) {
      return <ConsentGate consent={pendingConsents[0]} onDone={refetch} />
    }
  }

  // The org Terms gate, then the rewards entry fee (it waits for Terms itself).
  return (
    <>
      <TermsAcceptanceGate />
      <EntryFeeGate />
    </>
  )
}
